export const sportsnewSelectionIdentity = (source = {}) => ({
  shortOddId: source.shortOddId ?? source.short_odd_id ?? null,
  canonicalSelectionKey:
    source.canonicalSelectionKey ?? source.canonical_selection_key ?? null,
  canonicalLineKey: source.canonicalLineKey ?? source.canonical_line_key ?? null,
  canonicalPairKey: source.canonicalPairKey ?? source.canonical_pair_key ?? null,
  points: source.points ?? null,
  line: source.line ?? null,
  selectionLine:
    source.selectionLine
    ?? source.selection_line
    ?? source.normalizedSelection
    ?? null,
  groupingKey: source.groupingKey ?? source.grouping_key ?? null,
});
